<template>
    <div>
        <Header :type="3"></Header>
        <div class="banner">
            <div id="cooperate" class="free_experience" @click="toApply">申请合作</div>
        </div>
        <div v-if="!isMinView" class="product_service main_width main_color m_0">
            <div class="left">
                <ul class="list">
                    <li @click="tabClick" data-index="0" data-type="VIN" class="li"
                        :class="[{ 'li_active': type == 'VIN' }]">{{ titleData[0] }}</li>
                    <li @click="tabClick" data-index="1" data-type="EPC" class="li"
                        :class="[{ 'li_active': type == 'EPC' }]">{{ titleData[1] }}</li>
                    <li @click="tabClick" data-index="2" data-type="OEM" class="li"
                        :class="[{ 'li_active': type == 'OEM' }]">{{ titleData[2] }}</li>
                    <li @click="tabClick" data-index="3" data-type="Original" class="li"
                        :class="[{ 'li_active': type == 'Original' }]">{{ titleData[3] }}</li>
                    <li @click="tabClick" data-index="4" data-type="Maintain" class="li"
                        :class="[{ 'li_active': type == 'Maintain' }]">{{ titleData[4] }}</li>
                    <li @click="tabClick" data-index="5" data-type="Danger" class="li"
                        :class="[{ 'li_active': type == 'Danger' }]">{{ titleData[5] }}</li>
                    <li @click="tabClick" data-index="7" data-type="AbridgedEpc" class="li"
                        :class="[{ 'li_active': type == 'AbridgedEpc' }]">{{ titleData[7] }}</li>
                    <li @click="tabClick" data-index="8" data-type="CustomizedService" class="li"
                        :class="[{ 'li_active': type == 'CustomizedService' }]">{{ titleData[8] }}</li>
                </ul>
            </div>
            <div class="right">
                <div v-if="index == 0">
                    <div class="title">接口介绍</div>
                    <div class="text" style="margin-bottom: 48px;">
                        通过对接接口，可查询17位VIN编码对应的车辆详细信息，包括4S店销售型名称、品牌、型号、年款、排量、变速箱类型、发动机型号等车辆参数数据，
                        帮助用户对车辆信息的真伪、高低配等进行判断。适用于零件采购、二手车估值、车型信息查询等行业或业务领域。</div>
                    <div class="title">优势</div>
                    <div class="text" style="margin-bottom: 32px;">
                        <p>每日最大量的VIN查询量，常年累月的纠错反馈所带来的批量纠错，让数据越来越精准，这也是汽修宝作为汽后行业面向B端用户最大流量平台的优势体现。</p>
                        <p>人工校验，通过大量的人力结合人工智能算法进行建模分析，不断优化，不断验证，目前已累计校验1.3亿，涵盖市场3/5的车型保有量数据。</p>
                        <p>唯一车型，目前市场覆盖品牌、年款等最多的VIN库，也是VIN锁唯一车型覆盖面最大和最准的平台。</p>
                    </div>
                    <div id="VIN" class="dow" @click="download">
                        <img src="/static/images2/product_service_dow.png" alt="">下载接口文档
                    </div>
                </div>
                <div v-if="index == 1">
                    <div class="title">接口介绍</div>
                    <div class="text" style="margin-bottom: 48px;">通过对接接口，可查询90个品牌EPC车辆结构图与配件信息。</div>
                    <div class="title">优势</div>
                    <div class="text" style="margin-bottom: 32px;">
                        <p>业内涵盖品牌数最多，能锁VIN品牌数最多。 </p>
                        <p>各品牌数据结构经过不断的优化，几乎一致，更有利于对接使用，和降低用户的学习成本。</p>
                    </div>
                    <div id="EPC" class="dow" @click="download">
                        <img src="/static/images2/product_service_dow.png" alt="">下载接口文档
                    </div>
                    <img class="product_service_epc" src="/static/images2/product_service_epc.webp" alt="">
                </div>
                <div v-if="index == 2">
                    <div class="title">接口介绍</div>
                    <div class="text" style="margin-bottom: 48px;">
                        收录热门品牌车型合共2000万+原厂配件数据，数据信息维度丰富，包含配件适用车型、4S价格、实物规格、替换件、通用件、用量等数据信息</div>
                    <div class="title">优势</div>
                    <div class="text" style="margin-bottom: 32px;">
                        数据准确性高、数据覆盖率全、数据信息丰富、更新速度快
                    </div>
                    <div id="OEM" class="dow" @click="download">
                        <img src="/static/images2/product_service_dow.png" alt="">下载接口文档
                    </div>
                </div>
                <div v-if="index == 3">
                    <div class="title">接口介绍</div>
                    <div class="text" style="margin-bottom: 32px;">
                        通过对接接口，可查询车辆官方生产数据与常用配件信息，适用于车型信息查询和确认、二手车行业以及保养快修行业等，包括基本信息、发动机、变速器、 常用维修件、常用磨损件等信息
                    </div>
                    <div id="Original" class="dow" @click="download">
                        <img src="/static/images2/product_service_dow.png" alt="">下载接口文档
                    </div>
                    <div class="OriginalBox">
                        <div class="img_box">
                            <div class="index_box"><span>0{{ OriginalIndex }}</span> / 06</div>
                            <img src="/static/images/jt_btn_1.png" alt="" class="jt_btn_1 cp"
                                @click="setOriginalIndex('left')">
                            <img :src="'/static/images/OriginalBox_' + OriginalIndex + '.jpg'" alt=""
                                class="OriginalBox_img">
                            <img src="/static/images/jt_btn_2.png" alt="" class="jt_btn_2 cp"
                                @click="setOriginalIndex('right')">
                        </div>
                    </div>

                </div>
                <div v-if="index == 4">
                    <div class="title">接口介绍</div>
                    <div class="text" style="margin-bottom: 48px;">
                        通过对接接口，可查询车辆维修保养记录，对二手车交易的估值环节是一个有效的判断依据。
                    </div>
                    <div class="title">优势</div>
                    <div class="text" style="margin-bottom: 32px;">
                        <p>维修保养多数据展示，异常排查、部件排查、维修保养项目与材料等数据输出！</p>
                        <p>品牌覆盖率高，查得率高达90%，查询速度快，价格实惠！</p>
                    </div>
                    <div id="Maintain" class="dow" @click="download">
                        <img src="/static/images2/product_service_dow.png" alt="">下载接口文档
                    </div>
                </div>
                <div v-if="index == 5">
                    <div class="title">接口介绍</div>
                    <div class="text" style="margin-bottom: 48px;">
                        用户通过VIN码，便可查询到目标车辆的出险记录，报告将详细解读目标车辆重要部件的损伤情况，为车辆交易、车辆金融、车辆报价评估等业务提供重要的 决策参考依据。
                    </div>
                    <div class="title">优势</div>
                    <div class="text" style="margin-bottom: 32px;">
                        <p>急速响应，利于企业及时获取数据，提升服务体验。</p>
                        <p>标准的接口，对接方式简洁，减少企业开发成本，提高开发效率。</p>
                    </div>
                    <div id="Danger" class="dow" @click="download">
                        <img src="/static/images2/product_service_dow.png" alt="">下载接口文档
                    </div>
                </div>
                <div v-if="index == 7">
                    <div class="title">接口介绍</div>
                    <div class="text" style="margin-bottom: 40px;">
                        通过对接SDK，您的应用将拥有当前市面上最简单、直观、快捷的EPC查询体验。适用于零配件采购、保险定损等行业及领域。是唯一能匹配传统零配 件采购效率和体验的线上解决方案，在保险定损等业务场景，能有效的滤除零件低配高赔的风险，提高效益，形成业务规范。
                    </div>
                    <div class="content_video">
                        <video width="772" height="376" controls >
                        <source src="/static/media/video_epc.mp4" type="video/mp4">
                        <object data="/static/media/video_epc.mp4" width="320" height="240">
                            <embed width="772" height="376" src="movie.swf">
                        </object>
                        </video>
                    </div>
                </div>
                <div v-if="index == 8">
                    <div class="title">定制服务</div>
                    <div class="text" style="margin-bottom: 16px;">
                        欢迎各类商务定制开发洽谈，请致电：020-36328593
                    </div>
                    <div class="app_qxb">
                        <img src="/static/images2/app.png" alt="">
                        <div>下载汽修宝APP</div>
                        <div>体验更多功能</div>
                    </div>
                </div>

                <div v-if="index == 2 || index == 4 || index == 5 || index == 6" class="content_media_box">
                    <div class="mobile_slide_box">
                        <div class="mobile_slide_con_top">
                            <img src="/static/images/sj_top.png" alt="" class="img_icon1">
                        </div>
                        <div class="mobile_slide_con cp">
                            <img v-if="index == 2" src="/static/images/api_3.jpg" alt="" class="neirong_icon">
                            <img v-if="index == 4" src="/static/images/api_4.jpg" alt="" class="neirong_icon">
                            <img v-if="index == 5" src="/static/images/chuxian.jpg" alt="" class="neirong_icon">
                            <img v-if="index == 6" src="/static/images/chekuang.jpg" alt="" class="neirong_icon">
                        </div>
                        <div class="mobile_slide_con_bottom">
                            <img src="/static/images/sj_bottom.png" alt="" class="img_icon2">
                        </div>
                    </div>
                    <div class="mobile_slide_title">
                        <div class="mobile_slide_title_line"></div>
                        <div class="vertical-text">
                            <span>滑</span>
                            <span>动</span>
                            <span>手</span>
                            <span>机</span>
                            <span>查</span>
                            <span>看</span>
                            <span>演</span>
                            <span>示</span>
                        </div>
                        <div class="mobile_slide_title_line"></div>
                    </div>
                </div>
            </div>
        </div>
        <h5ProductService class="main_color" v-else />
        
        <modal v-model="showModal" title="" @confirm="onConfirm" @cancel="onCancel">
            <form class="main_color">
                <div class="form-group">
                    <label>您想合作的方向是？</label>
                    <!-- <input type="text" v-model="modalData.title" maxlength="100"></input> -->
                     <select v-model="modalData.title">
                        <option value="商城入驻"><div>商城入驻</div></option>
                        <option value="商务&数据合作">商务&数据合作</option>
                    </select>
                </div>
                <div class="form-group">
                    <label>联系方式</label>
                    <input type="text" v-model="modalData.phone" maxlength="15"></input>
                </div>
                <div class="form-group">
                    <label>联系人</label>
                    <input type="text" v-model="modalData.username" maxlength="20"></input>
                </div>
            </form>
        </modal>
    </div>
</template>
<script>
import Header from '../../components/header.vue'
import h5ProductService from './h5_product_service.vue'
import modal from '../../components/modal.vue';
import { isMinView, onEventGsIdo } from '../../utils/index.js'
export default {
    name: "productService",
    components: {
        Header,
        h5ProductService,
        modal
    },
    data() {
        return {
            type: 'VIN',
            titleData: [
                '车架号(VIN)接口',
                '结构图(EPC)接口',
                'OEM查询接口',
                '原厂数据查询接口',
                '维修保养记录接口',
                '出险记录接口',
                '车辆状况查询接口',
                '简版EPC',
                '定制服务'
            ],
            index: 0,
            OriginalIndex: 1,
            isMinView: isMinView(),
            showModal: false,
            modalData: {
                title: '商务&数据合作',
                phone: '',
                username: ''
            }
        }
    },
    watch: {
        '$route' (to, from) { // 监听路由是否变化
            this.change()
        }
    },
    created(){
        this.change()
    },
    methods: {
        tabClick(e) {
            var item = e.currentTarget.dataset
            this.type = item.type
            this.index = item.index
        },
        change(){
            var _this = this
            this.type = this.$route.query.type?this.$route.query.type:'VIN'

            switch (_this.type) {
                case 'VIN':
                    _this.index = 0
                    break;
                case 'EPC':
                    _this.index = 1
                    break;
                case 'OEM':
                    _this.index = 2
                    break;
                case 'Original':
                    _this.index = 3
                    break;
                case 'Maintain':
                    _this.index = 4
                    break;
                case 'Danger':
                    _this.index = 5
                    break;
                case 'Vehicle':
                    _this.index = 6
                    break;
                case 'AbridgedEpc':
                    _this.index = 7
                    break;
                case 'CustomizedService':
                    _this.index = 8
                    break;
                default:
                    _this.index = 0
            }
        },
        download() {
            let url = 'https://img1.nanxinwang.com/apps/file/pdf/file2.pdf'
            var _this = this
            switch (_this.type) {
                case 'VIN':
                    url = 'https://img1.nanxinwang.com/apps/file/pdf/file2.pdf'
                    onEventGsIdo('qxb_$VIN', '下载VIN接口文档')
                    break;
                case 'EPC':
                    url = 'https://img1.nanxinwang.com/apps/file/pdf/file4.pdf'
                    onEventGsIdo('qxb_$EPC', '下载EPC接口文档')
                    break;
                case 'OEM':
                    url = 'https://img1.nanxinwang.com/apps/file/pdf/file1.pdf'
                    onEventGsIdo('qxb_$OEM', '下载OEM接口文档')
                    break;
                case 'Original':
                    url = 'https://img1.nanxinwang.com/apps/file/pdf/file6.pdf'
                    onEventGsIdo('qxb_$Original', '下载原厂接口文档')
                    break;
                case 'Maintain':
                    url = 'https://img1.nanxinwang.com/apps/file/pdf/file5.pdf'
                    onEventGsIdo('qxb_$Maintain', '下载维保接口文档')
                    break;
                case 'Danger':
                    url = 'https://img1.nanxinwang.com/apps/file/pdf/file3.pdf'
                    onEventGsIdo('qxb_$Danger', '下载出险接口文档')
                    break;
                case 'AbridgedEpc':
                    url = 'https://img1.nanxinwang.com/apps/file/pdf/file4.pdf'
                    onEventGsIdo('qxb_$EPC', '下载EPC接口文档')
                    break;
                default:
                    url = 'https://img1.nanxinwang.com/apps/file/pdf/file2.pdf'
                    onEventGsIdo('qxb_$VIN', '下载VIN接口文档')
            }
            window.open(url)
        },
        setOriginalIndex(type) {
            if (type == 'left') {
                --this.OriginalIndex
                if (this.OriginalIndex <= 0) {
                    this.OriginalIndex = 6
                }
            } else {
                ++this.OriginalIndex
                if (this.OriginalIndex >= 7) {
                    this.OriginalIndex = 1
                }
            }
        },
        toApply() {
            this.showModal = true
            onEventGsIdo('qxb_$apply', '申请合作')
        },
        async onConfirm() {
            onEventGsIdo('qxb_$submit_form', '提交表单')
            if(!this.modalData.phone) {
                onEventGsIdo('qxb_$submit_form_error', `提交表单失败-请输入联系方式！`)
                alert('请输入联系方式！')
                return
            }
            if(!this.modalData.username) {
                onEventGsIdo('qxb_$submit_form_error', `提交表单失败-请输入联系人！`)
                alert('请输入联系人！')
                return
            }
            const formData = new FormData();
            formData.append('title', this.modalData.title);
            formData.append('phone', this.modalData.phone);
            formData.append('username', this.modalData.username);
            try {
                const response = await fetch(`https://api.qixiubao.cn/api/?version=5.20.0.3&action=API.Article.addCooperate&title=${this.modalData.title}&username=${this.modalData.username}&phone=${this.modalData.phone}`, {
                    method: 'POST',
                    body: formData
                })
                if (!response.ok) {
                    throw new Error('网络响应失败');
                }

                const data = await response.json();
                if(data.code == 200) {
                    this.showModal = false
                    this.$message({
                        type: null,
                        title: '提交成功！',
                        position: 'center',
                        duration: 3000,
                        closable: true,
                        collapsable: false
                    })
                    onEventGsIdo('qxb_$submit_form_success', '提交表单成功')
                } else {
                    alert(data.message)
                    onEventGsIdo('qxb_$submit_form_error', `提交表单失败-${data.message}`)
                }
                console.log('请求成功:', data);
            } catch (error) {
                console.error('请求失败:', error);
            }
        },
        onCancel() {
            this.showModal = false
        }
    }
}
</script>
<style scoped lang="less">
@import "../../assets/style/utils.less";
.banner {
    height: 25vw;
    // min-height: 330px;
    width: 100%;
    background-image: url('../../../static/images2/product_service.webp');
    background-color: #ebf2fe;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    .free_experience {
        width: .px2vw(340)[@result];
        height: .px2vw(56)[@result];
        line-height: .px2vw(56)[@result];
        background: #165DFF;
        color: #FFFFFF;
        font-weight: 400;
        font-size: .px2vw(14)[@result];
        border-radius: .px2vw(2)[@result];
        cursor: pointer;
        text-align: center;
        margin-bottom: .px2vw(40)[@result];
        
    }
}

.product_service {
    width: .px2vw(1280)[@result];
    padding: .px2vw(56)[@result] 0;
    display: flex;
    margin: 0 auto;
    .left {
        border-right: 1px solid #D8D8D8;
        height: .px2vw(708)[@result];

        .list {
            &>li {
                width: .px2vw(195)[@result];
                height: .px2vw(56)[@result];
                line-height: .px2vw(56)[@result];
                font-weight: 400;
                font-size: .px2vw(16)[@result];
                border-radius: .px2vw(4)[@result];
                margin-bottom: .px2vw(8)[@result];
                padding-left: .px2vw(16)[@result];
                cursor: pointer;

                &:hover {
                    background: #E8F3FF;
                    color: #165DFF;
                }
            }

            .li_active {
                background: #165DFF !important;
                color: #FFFFFF !important;
            }
        }
    }

    .right {
        margin-left: .px2vw(80)[@result];

        .title {
            font-weight: 600;
            font-size: .px2vw(20)[@result];
            margin-bottom: .px2vw(16)[@result];
        }

        .text {
            font-weight: 400;
            font-size: .px2vw(14)[@result];
            line-height: .px2vw(22)[@result];

        }

        .dow {
            display: flex;
            align-items: center;
            justify-content: center;
            width: .px2vw(148)[@result];
            font-size: .px2vw(14)[@result];
            color: #165DFF;
            border-radius: .px2vw(2)[@result];
            border: 1px solid #165DFF;
            line-height: .px2vw(22)[@result];
            padding: .px2vw(7)[@result] 0;
            margin-bottom: .px2vw(32)[@result];
            cursor: pointer;

            img {
                width: .px2vw(16)[@result];
                height: .px2vw(16)[@result];
                margin-right: .px2vw(3)[@result];
            }
        }

        .product_service_epc {
            width: .px2vw(774)[@result];
            height: .px2vw(436)[@result];
        }
        .content_video{
            width: .px2vw(772)[@result];
            height: .px2vw(390)[@result];
        }
        .app_qxb {
            text-align: center;
            width: .px2vw(220)[@result];
            line-height: .px2vw(22)[@result];
            img {
                width: .px2vw(220)[@result];
                height: .px2vw(220)[@result];
                margin-bottom: .px2vw(12)[@result];
            }
        }
    }
}

// 旧样式
.OriginalBox {
    .img_box {
        width: .px2vw(800)[@result];
        height: .px2vw(800)[@result];
        position: relative;

        .index_box {
            font-size: .px2vw(16)[@result];
            color: #999;

            span {
                color: #000;
            }

            position: absolute;
            right: .px2vw(18)[@result];
            width: .px2vw(100)[@result];
            top: .px2vw(30)[@result];
            height: .px2vw(30)[@result];
            line-height: .px2vw(30)[@result];
        }

        .OriginalBox_img {
            width: .px2vw(800)[@result];
            height: .px2vw(800)[@result];
        }

        .jt_btn_1 {
            position: absolute;
            width: .px2vw(58)[@result];
            height: .px2vw(58)[@result];
            top: 50%;
            left: .px2vw(-29)[@result];
            transform: translate(0, -50%);
        }

        .jt_btn_2 {
            position: absolute;
            width: .px2vw(58)[@result];
            height: .px2vw(58)[@result];
            top: 50%;
            right: .px2vw(-29)[@result];
            transform: translate(0, -50%);
        }
    }

    .zhu {
        font-size: .px2vw(16)[@result];
        text-align: left;
        margin-left: .px2vw(10)[@result];
        margin-top: .px2vw(30)[@result];
        color: #646A7F;
    }
}

// 改旧样式
.content_media_box {
    display: flex;
    align-items: center;
    .mobile_slide_box {
        text-align: center;

        .mobile_slide_con::-webkit-scrollbar {
            width: 0px;
            height: 0px;
        }

        .mobile_slide_con .-o-scrollbar {
            -moz-appearance: none !important;
            background: rgba(0, 255, 0, 0) !important;
        }

        .mobile_slide_con {
            -ms-scroll-chaining: chained;
            -ms-overflow-style: none;
            -ms-content-zooming: zoom;
            -ms-scroll-rails: none;
            -ms-content-zoom-limit-min: 100%;
            -ms-content-zoom-limit-max: 500%;
            -ms-scroll-snap-type: proximity;
            -ms-scroll-snap-points-x: snapList(100%, 200%, 300%, 400%, 500%);
            -ms-overflow-style: none;
            overflow: auto;
        }

        .mobile_slide_con_top {
            width: .px2vw(373)[@result];
        }

        .mobile_slide_con {
            position: relative;
            width: .px2vw(373)[@result];
            height: .px2vw(542)[@result];
            overflow-y: auto;
            // margin: 0 auto;
            background: url(/static/images/sj_con.png) no-repeat;
            background-size: cover;
            box-sizing: border-box;

            /*padding-top: 20px;*/
            /*padding-bottom: 20px;*/
            .img_icon1 {
                width: .px2vw(373)[@result];
                height: .px2vw(699)[@result];
                position: absolute;
                top: 0;
                left: 50%;
                transform: translate(-50%, 0);
            }

            .neirong_icon {
                width: .px2vw(276)[@result];
                margin-left: .px2vw(16)[@result];
                /*height: 1127px;*/
            }
        }
        .mobile_slide_con_bottom {
            width: .px2vw(373)[@result];
        }
    }
    .mobile_slide_title {
        .mobile_slide_title_line {
            height: .px2vw(152)[@result];
            width: 1px;
            background-color: #1D2129;
            margin-left: .px2vw(8)[@result];
        }
        .vertical-text {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
    }
}

.form-group {
    label {
        font-weight: 700;
        font-size: 16px;
        margin-bottom: 16px;
        display: inline-block;
    }
    input {
        height: 48px;
        width: 100%;
        background: #ECEFF9;
        border-radius: 6px 6px 6px 6px;
        padding: 0 10px;
        margin-bottom: 32px;
        box-sizing: border-box;
    }
    select {
        height: 48px;
        width: 100%;
        background: #ECEFF9;
        border-radius: 6px 6px 6px 6px;
        padding: 0 30px 0 10px;
        margin-bottom: 32px;
        border: none;
        outline: 0;
    }
}


@media screen and (max-width: 900px) {
    .banner {
        height: .h5px2vw(250)[@result];
        background-image: url('../../../static/images2/h5/product_service.webp');
        .free_experience {
            display: none;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/productService/index.vue